import { z } from '@exodus/zod';
import { memoize } from '@exodus/basic-utils';
const PRIVATE_ASSETS = new Set(['monero']);
const createOrdersReport = ({ ordersAtom }) => ({
    namespace: 'orders',
    export: async ({ walletExists } = Object.create(null)) => {
        if (!walletExists)
            return null;
        const ordersData = await ordersAtom.get();
        const redactedData = ordersData.toRedactedJSON();
        const ordersWithoutPrivateAssets = redactedData
            .filter(({ fromAsset, toAsset }) => {
            const from = fromAsset ?? '';
            const to = toAsset ?? '';
            return !PRIVATE_ASSETS.has(from) && !PRIVATE_ASSETS.has(to);
        })
            .map((redacted) => ({
            ...redacted,
            fromAmount: (() => {
                if (!redacted.fromAmount)
                    return;
                const order = ordersData.get(redacted.orderId);
                return order?.fromAmount?.toDefaultString({ unit: true });
            })(),
            toAmount: (() => {
                if (!redacted.toAmount)
                    return;
                const order = ordersData.get(redacted.orderId);
                return order?.toAmount?.toDefaultString({ unit: true });
            })(),
        }));
        return { data: ordersWithoutPrivateAssets };
    },
    getSchema: memoize(() => {
        const orderSchema = z
            .object({
            orderId: z.string(),
            date: z.string().optional(),
            status: z.string().optional(),
            fromAsset: z.string().optional(),
            toAsset: z.string().optional(),
            fromAmount: z.string().optional(),
            toAmount: z.string().optional(),
            svc: z.string().optional(),
            fromWalletAccount: z.string().optional(),
            toWalletAccount: z.string().optional(),
            message: z.string().optional(),
            region: z.string().optional(),
            synced: z.boolean().optional(),
            slippage: z.number().optional(),
            hasError: z.boolean().optional(),
        })
            .strict();
        return z
            .object({
            data: z.array(orderSchema),
        })
            .strict()
            .nullable();
    }),
});
const ordersReportDefinition = {
    id: 'ordersReport',
    type: 'report',
    factory: createOrdersReport,
    dependencies: ['ordersAtom'],
    public: true,
};
export default ordersReportDefinition;
